import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component, createRef } from "react";
import { JobArrangerEntities } from "../JobArrangerEntities";
import { JobArrangerLayout } from "../JobArrangerLayout";
import { JobArrangerProps } from "../JobArrangerProps";
import { JobStatusHistory } from "../components/JobStatusHistory";
import { JobStatusPanel } from "../components/JobStatusPanel";

interface JobViewPageProps extends NSARouterMakerResult, JobArrangerProps { }

class JobViewPage extends Component<JobViewPageProps>
{
    private LayoutRef = createRef<JobArrangerLayout>();
    private JobStatusPanel_Ref = createRef<JobStatusPanel>();
    private JobStatusHistory_Ref = createRef<JobStatusHistory>();

    override render()
    {
        return (
            <JobArrangerLayout
                {...this.props}
                ref={this.LayoutRef}
                pages={{
                    entity: JobArrangerEntities.job(this.props),
                    view: {
                        ui: {
                            getChildrenAfter: (_id, row) =>
                            {
                                if (!row)
                                    return null;

                                return (
                                    <>
                                        <JobStatusPanel
                                            {...this.props}
                                            ref={this.JobStatusPanel_Ref}
                                            job={row}
                                            onChange={() =>
                                            {
                                                this.LayoutRef.current?.NSALayout_Ref.current?.NSASectionView_Ref.current?.reload();
                                                this.JobStatusHistory_Ref.current?.load();
                                            }}
                                        />
                                        <JobStatusHistory
                                            {...this.props}
                                            ref={this.JobStatusHistory_Ref}
                                            job={row}
                                            onChange={() => this.JobStatusPanel_Ref.current?.reloadJob()}
                                        />
                                    </>
                                )
                            }
                        },
                    }
                }}
            >
                <></>
            </JobArrangerLayout>
        );
    }
}

export default JobViewPage;